import { render, staticRenderFns } from "./intelligence.vue?vue&type=template&id=ebb54238&scoped=true"
import script from "./intelligence.vue?vue&type=script&lang=js"
export * from "./intelligence.vue?vue&type=script&lang=js"
import style0 from "./intelligence.vue?vue&type=style&index=0&id=ebb54238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb54238",
  null
  
)

export default component.exports